<template>
  <b-button
    v-if="appLoaded && canBuild"
    class="builder-button"
    variant="light"
    size="sm"
    data-cy="toggle-builder"
    @click="toggleBuilder"
  >
    <font-awesome-icon :icon="icon" />
  </b-button>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { useBuilderStore } from '@/store/admin/builder'

import {
  ROUTE_BUILDER_PRIMARY,
  ROUTE_SIDEBAR_SETTINGS,
  goToStudio,
} from '@/constants'

@Component
export default class ShowHideBuilder extends Vue {
  builder = useBuilderStore()

  get isBuilder () {
    return this.$typedStore.currentRoute.isBuilder
  }

  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }

  get icon () {
    return this.isBuilder ? 'chevron-left' : 'chevron-right'
  }

  get canBuild () {
    return this.appLoaded && this.$typedStore.admin.userPermission.builder
  }

  get sidepanel () {
    return this.builder.lastUsedSidepanel ?? ROUTE_SIDEBAR_SETTINGS
  }

  toggleBuilder () {
    // storyPath is not being preserved for some reason so add manually
    const { storyPath } = this.$typedStore.currentRoute.params
    if (this.isBuilder) {
      this.$router.push({
        name: 'readOnly',
        params: { storyPath },
      })
    } else {
      if (this.canBuild) {
        this.$router.push({
          name: ROUTE_BUILDER_PRIMARY,
          params: { sidepanel: this.sidepanel, storyPath },
        })
      } else {
        window.open(goToStudio(this.$typedStore.currentRoute.primaryAppId), '_self')
      }
    }
  }
}
</script>

<style>

.builder-button {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1021;
}

</style>
